<template>
  <div class=" tw-h-full tw-w-full tw-p-2 tw-h-svh lg:tw-p-4 tw-bg-light">
    <div
      class="tw-flex tw-flex-col lg:tw-flex-row tw-items-center tw-w-full tw-h-full"
    >
      <div
        class="tw-w-full lg:tw-w-2/5 tw-flex tw-flex-col tw-gap-2 tw-justify-between tw-bg-primary tw-p-8 xl:tw-p-12 tw-rounded-md tw-h-full"
      >
        <div class="tw-flex tw-flex-col tw-gap-4 lg:tw-gap-8">
          <img
            class="tw-w-28"
            src="@/assets/logonewfull.svg"
            alt="Kitchenly Logo"
          />
          <div class="tw-flex tw-flex-col tw-gap-2 xl:tw-gap-6">
            <span
              class="tw-w-full tw-text-3xl tw-font-semibold tw-leading-tight xl:tw-text-4xl lg:tw-text-2xl tw-text-light lg:tw-w-3/4"
              >Simplifying Property Rentals for You</span
            >
            <span class="tw-text-light tw-text-sm tw-opacity-50">
              Manage your properties efficiently with our advanced Property
              Management platform. Whether you're a property owner, manager, or
              tenant, our platform helps streamline rent collection, lease
              management, and property listings, making property rentals easier
              than ever before.
            </span>
          </div>
        </div>

        <div
          class="mt-4 tw-w-full lg:tw-hidden tw-block lg:tw-w-3/5 tw-bg-light tw-rounded-md tw-p-4"
        >
          <UserSignInForm />
        </div>
      </div>
      <div class="tw-w-full tw-hidden lg:tw-block lg:tw-w-3/5 tw-p-14">
        <UserSignInForm />
      </div>
    </div>
  </div>
</template>

<script>
import UserSignInForm from "@/user/components/UserSignInForm.vue";

export default {
  components: {
    UserSignInForm
  }
};
</script>

<style></style>
